module.exports = __webpack_public_path__ + "static/media/M12ws.5cfa178f.pdf";